<template>
  <div style="min-height: 120px; margin-top: 5px;" v-if="isLoading">
    <div class="categorys2" v-if="isLoading && lists">
      <button style="width: 60px;" @click="selectMarket('STAR')">
        <img src="@/assets/img/ico/favor_on.png">
      </button>
      <button @click="selectMarket(null)">
        전체
      </button>
      <button @click="selectMarket('승무패')">
        승무패
      </button>
      <button @click="selectMarket('핸디캡')">
        핸디캡
      </button>
      <button @click="selectMarket('오버언더')">
        오버언더
      </button>
      <button @click="selectMarket('ETC')">
        기타
      </button>
    </div>

    <template v-if="!selectedMarket">
      <div class="m-game2" v-for="(row, index) in marketSort(originList)" :key="'mobileDetailMarket'+index">
        <div class="head" v-if="lists.filter(e => String(e.marketId) === String(row.id))?.find(f => f.isVisible ==='y')">
          <div class="tit">
            {{ row | marketNameLsport(game) }}
          </div>
          <div class="right">
            <span @click="folderClosed(row.seq, '0')" class="material-icons" :class="{'up': closed.find(e => e.seq === row.seq), 'down': !closed.find(e => e.seq === row.seq )}">expand_more</span>
          </div>
        </div>
        <div class="body" v-if="!closed.find(e => e.seq === row.seq)">
          <template
              v-if="row2.bets.length < 4"
              v-for="(row2, index2) in lists.filter(e => String(e.marketId) === String(row.id))"
          >
            <div class="item" :key="'marketFolderDetail'+index2">
              <template v-if="(row2.isSuspended === 'y' && row2.isVisible === 'y') || game.isSuspended === 'y'">
                <MDetailLock></MDetailLock>
                <MDetailLock
                    v-if="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'NoGoal')"
                ></MDetailLock>
                <MDetailLock></MDetailLock>
              </template>
              <template v-else-if="row2.isSuspended === 'n' && row2.isVisible === 'y'">
                <MDetailPrice
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === '1X' || e.name === 'Odd' || e.name === 'Yes' || e.name === 'Home' || e.name === 'Team1')"
                    :folder="row2"
                    :game="game"
                    :team="game.homeTeam"
                >
                </MDetailPrice>
                <MDetailPrice
                    v-if="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'NoGoal')"
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'NoGoal')"
                    :folder="row2"
                    :game="game"
                    :team="game.homeTeam"
                >
                </MDetailPrice>
                <MDetailPrice
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'X2' || e.name === 'Even' || e.name === 'No' || e.name === 'Away' || e.name === 'Team2')"
                    :folder="row2"
                    :game="game"
                    :team="game.awayTeam"
                >
                </MDetailPrice>
              </template>
            </div>
          </template>
          <template v-else-if="row2.bets.length === 4">
            <template v-for="l in arrLenDiv(row2.bets, 2)">
              <template v-if="(row2.isVisible === 'y' && row2.isSuspended === 'y') || game.isSuspended === 'y'">
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 2, l * 2)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      <img style="width: 9px;" src="@/assets/img/ico/ico_secret.png">
                    </dd>
                  </dl>
                </div>
              </template>
              <template v-else>
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 2, l * 2)"
                      :class="{'active': checkCart(bet)}"
                      @click="addCart(bet, row2, game)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      {{ bet.price }}
                    </dd>
                  </dl>
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-for="l in arrLenDiv(row2.bets, 3)">
              <template v-if="(row2.isVisible === 'y' && row2.isSuspended === 'y') || game.isSuspended === 'y'">
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 3, l * 3)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      <img style="width: 9px;" src="@/assets/img/ico/ico_secret.png">
                    </dd>
                  </dl>
                </div>
              </template>
              <template v-else>
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 3, l * 3)"
                      :class="{'active': checkCart(bet)}"
                      @click="addCart(bet, row2, game)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      {{ bet.price }}
                    </dd>
                  </dl>
                </div>
              </template>
            </template>

          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="m-game2" v-for="(row, index) in marketSort(lists)" :key="'mobileDetailMarket'+index">
        <div class="head" v-if="lists.filter(e => String(e.marketId) === String(row.id))?.find(f => f.isVisible ==='y')">
          <div class="tit">
            {{ row | marketNameLsport(game) }}
          </div>
          <div class="right">
            <span @click="folderClosed(row.seq, '0')" class="material-icons" :class="{'up': closed.find(e => e.seq === row.seq ), 'down': !closed.find(e => e.seq === row.seq )}">expand_more</span>
          </div>
        </div>
        <div class="body" v-if="!closed.find(e => e.seq === row.seq)">
          <template
              v-if="row2.bets.length < 4"
              v-for="(row2, index2) in lists.filter(e => String(e.marketId) === String(row.id))"
          >
            <div class="item" :key="'marketFolderDetail'+index2">
              <template v-if="(row2.isSuspended === 'y' && row2.isVisible === 'y') || game.isSuspended === 'y'">
                <MDetailLock></MDetailLock>
                <MDetailLock
                    v-if="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal')"
                ></MDetailLock>
                <MDetailLock></MDetailLock>
              </template>
              <template v-else-if="row2.isSuspended === 'n' && row2.isVisible === 'y'">
                <MDetailPrice
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === '1X' || e.name === 'Odd' || e.name === 'Yes' || e.name === 'Home' || e.name === 'Team1')"
                    :folder="row2"
                    :game="game"
                    :team="game.homeTeam"
                >
                </MDetailPrice>
                <MDetailPrice
                    v-if="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal')"
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal')"
                    :folder="row2"
                    :game="game"
                    :team="game.homeTeam"
                >
                </MDetailPrice>
                <MDetailPrice
                    :add-cart="addCart"
                    :check-cart="checkCart"
                    :bets="row2.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'X2' || e.name === 'Even' || e.name === 'No' || e.name === 'Away' || e.name === 'Team2')"
                    :folder="row2"
                    :game="game"
                    :team="game.awayTeam"
                >
                </MDetailPrice>
                <!--              <dl-->
                <!--                  :set="home=row2.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === '1X' || e.name === 'Odd' || e.name === 'Yes')"-->
                <!--                  :class="{'active': checkCart(home=row2.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === '1X' || e.name === 'Odd' || e.name === 'Yes'))}"-->
                <!--                  @click="addCart(home=row2.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === '1X' || e.name === 'Odd' || e.name === 'Yes'), row2)"-->
                <!--              >-->
                <!--                <dt>-->
                <!--                  {{ home.name | betsName }} {{row2.folders_line | lineSet2(home.name)}}-->
                <!--                </dt>-->
                <!--                <dd>-->
                <!--              <span-->
                <!--                  v-if="home.name === 'Over'"-->
                <!--                  class="material-icons up"-->
                <!--              >expand_more-->
                <!--              </span>-->
                <!--                  {{ home.price }}-->
                <!--                </dd>-->
                <!--              </dl>-->
                <!--              <dl-->
                <!--                  v-if="row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal')"-->
                <!--                  :class="{'active': checkCart(draw=row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal'))}"-->
                <!--                  @click="addCart(draw=row2.bets.find(e => e.name === 'X' || e.name === '12' || e.name === 'No Goal'), row2)"-->
                <!--              >-->
                <!--                <dt>-->
                <!--                  {{ draw.name | betsName }} {{ draw.line }}-->
                <!--                </dt>-->
                <!--                <dd>-->
                <!--                  {{ draw.price }}-->
                <!--                </dd>-->
                <!--              </dl>-->
                <!--              <dl-->
                <!--                  :set="away=row2.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'X2' || e.name === 'Even' || e.name === 'No')"-->
                <!--                  :class="{'active': checkCart(row2.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'X2' || e.name === 'Even' || e.name === 'No'))}"-->
                <!--                  @click="addCart(row2.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'X2' || e.name === 'Even' || e.name === 'No'), row2)"-->
                <!--              >-->
                <!--                <dt>-->
                <!--                  {{ away.name | betsName}} {{ row2.folders_line | lineSet2(away.name, '2')}}-->
                <!--                </dt>-->
                <!--                <dd>-->
                <!--                  <span v-if="away.name === 'Under'" class="material-icons down">expand_more</span>-->
                <!--                  {{ away.price }}-->
                <!--                </dd>-->
                <!--              </dl>-->
              </template>
            </div>
          </template>
          <template v-else-if="row2.bets.length === 4">
            <template v-for="l in arrLenDiv(row2.bets, 2)">
              <template v-if="(row2.isVisible === 'y' && row2.isSuspended === 'y') || game.isSuspended === 'y'">
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 2, l * 2)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      <img style="width: 9px;" src="@/assets/img/ico/ico_secret.png">
                    </dd>
                  </dl>
                </div>
              </template>
              <template v-else>
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 2, l * 2)"
                      :class="{'active': checkCart(bet)}"
                      @click="addCart(bet, row2, game)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      {{ bet.price }}
                    </dd>
                  </dl>
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-for="l in arrLenDiv(row2.bets, 3)">
              <template v-if="(row2.isVisible === 'y' && row2.isSuspended === 'y') || game.isSuspended === 'y'">
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 3, l * 3)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      <img style="width: 9px;" src="@/assets/img/ico/ico_secret.png">
                    </dd>
                  </dl>
                </div>
              </template>
              <template v-else>
                <div class="item" :key="'CorrectScoreBets' + l">
                  <dl
                      v-for="bet in row2.bets.slice((l - 1) * 3, l * 3)"
                      :class="{'active': checkCart(bet)}"
                      @click="addCart(bet, row2, game)"
                      :key="'betsDetail'+bet.id"
                      style="width: 33%;"
                  >
                    <dt>
                      {{ manyBetsName(bet)}}
                    </dt>
                    <dd>
                      {{ bet.price }}
                    </dd>
                  </dl>
                </div>
              </template>
            </template>

          </template>
        </div>
      </div>
    </template>
  </div>
  <div style="text-align: center; min-height: 120px;" v-else>
    <Loading style="margin-top: 30px; "></Loading>
  </div>
</template>

<script>
import MDetailLock from '@/components/Game/Sports/European/MLsportDetailLock'
import MDetailPrice from '@/components/Game/Sports/European/MLsportDetailPrice'
import Loading from '@/components/Loading'
import MSG from '@/contants/msg'
import {mapState} from "vuex";

export default {
  name: "Detail",
  components: {
    MDetailLock,
    MDetailPrice,
    Loading,
  },
  props: ['game'],
  data: function () {
    return {
      cartType: 'sports',
      originList: null,
      lists: null,
      isLoading: false,
      selectedMarket: null,
      closed: [],
    }
  },
  mounted: function () {
    // this.$store.dispatch('CLEAR_LSPORT_CART')
    this.initFolder();
    setTimeout(() => {
      this.isLoading = true;
    }, 2000);
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      cartItem: state => state.lsport.cart,
    }),
  },
  watch: {
    selectedMarket: function (val) {
      if (!val) return this.lists = this.originList;
      if (val === '승무패') {
        return this.lists = this.originList.filter(e =>
          e.market.nameKr?.indexOf('승무패') >= 0 || e.market.nameKr?.indexOf('승패') >= 0
        );
      }

      if (val === '핸디캡') {
        return this.lists = this.originList.filter(e => e.market.nameKr?.indexOf('핸디캡') >= 0);
      }

      if (val === '오버언더') {
        return this.lists = this.originList.filter(e => e.market.nameKr?.indexOf('오버언더') >= 0);
      }

      if (val === 'ETC') {
        return this.lists = this.originList.filter(e =>
          !e.market.nameKr ||
          (e.market.nameKr.indexOf('승무패') < 0 &&
           e.market.nameKr.indexOf('승패') < 0 &&
           e.market.nameKr.indexOf('핸디캡') < 0 &&
           e.market.nameKr.indexOf('오버언더') < 0)
        );
      }

      // if (val === 'STAR') {
      //   console.log(this.stared);
      //   this.lists = [];
      //   this.stared.map(s => {
      //     const lists = this.originList.filter(l => String(s.gameId) === String(this.game.id) && String(s.seq) === String(l.marketSeq) && String(s.periodSequence) === String(l.periodSequence))
      //     lists.map(folder => this.lists.push(folder));
      //   })
      //
      //   return;
      // }


      this.lists = this.originList.filter(e => e.market.nameKr?.indexOf(val) >= 0);
    }
  },
  methods: {
    initFolder: function () {
      const payload = {
        gameId: this.game.id
      }

      return this.$store.dispatch('GET_LSPORT_DETAIL',  { payload })
          .then(data => {
            let result = null;
            if (Array.isArray(data)){
              result = data[0].data;
            } else {
              result = data.data;
            }
            this.game = result.payload.game;
            this.originList = result.payload.list;
            this.lists = this.originList;
            this.isLoading = true;
          }).catch(err => {
            alert(err.response.data.error);
          })
    },
    // 마켓선택
    selectMarket: function (market) {
      this.selectedMarket = market;
    },
    // 마켓정렬
    marketSort: function (lists) {
      const markets = lists.map(e => e.market);
      const arrUnique = markets.filter((character, idx, arr) => {
        return arr.findIndex((item) => item.id === character.id) === idx
      });
      arrUnique.sort()
      return arrUnique
    },
    // 베팅카트에 담기
    addCart: function (bets, folders, game) {
      if (!this.user) return alert(MSG.isNotLogin);
      const config = this.user.members_detail_setting;
      if (!config.베팅권한.유럽형.active) {
        return alert(MSG.authorization);
      }
      const cartItem = {
        gameId: game.id,
        gameSeq: game.seq,
        betsSeq: bets.seq,
        betsStatus: bets.status,
        betsId: bets.id,
        betsName: bets.name,
        betsUpdated: false,
        betsPrevOdds: bets.price,
        sportsId: game.sportSeq,
        foldersSeq: folders.seq,
        foldersType: folders.type,
        foldersStatus: folders.status,
        odds: bets.price,
        line: bets.line ? bets.line : null,
        leagueId: game.leagueId,
        leagueNameKr: game.league.nameKr,
        leagueNameEn: game.league.nameEn,
        leagueNameIcon: game.league.icon,
        sportNameKr: game.sport.nameKr,
        sportNameEn: game.sport.nameEn,
        sportNameIcon: game.sport.icon,
        homeNameKr: game.homeTeam.nameKr,
        homeNameEn: game.homeTeam.nameEn,
        awayNameKr: game.awayTeam.nameKr,
        awayNameEn: game.awayTeam.nameEn,
        marketNameKr: folders.market.nameKr,
        marketNameEn: folders.market.nameEn,
        marketsId: folders.marketId,
        maxAmount: game.league?.maxAmount,
        startTime: game.startTime,
        odds1: folders.line,
        odds2: null,
        odds3: null,
        betType: '프리매치(엘스포츠-유럽형)',
        detailType: null,
        currentPeriod: game.currentPeriod,
        currentTime: game.currentTime,
        homeScore: game.homeResult,
        awayScore: game.awayResult,
        penalty: null
      };

      this.$store.dispatch('ADD_LSPORT_EUROPEAN_CART_ITEM', cartItem)
    },
    addStartedMarket: function (seq, period) {
      console.log(seq, period);
      const market = {
        gameId: this.game.id,
        seq: seq,
        periodSequence: period,
      }
      this.$store.dispatch('list/started', market);
    },
    manyBetsName: function (bet) {
      let name = bet.name;
      if (name.indexOf('1 And Over') >= 0) {
        name = name.replace('1 And Over', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 오버`)
      }
      if (name.indexOf('2 And Over') >= 0) {
        name = name.replace('2 And Over', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 오버`)
      }
      if (name.indexOf('12 And Over') >= 0) {
        name = name.replace('12 And Over', '12 & 오버')
      }
      if (name.indexOf('1 And Under') >= 0) {
        name = name.replace('1 And Under', `${this.game.homeTeam.nameKr || this.game.homeTeam.nameEn} & 언더`)
      }
      if (name.indexOf('2 And Under') >= 0) {
        name = name.replace('2 And Under', `${this.game.awayTeam.nameKr || this.game.awayTeam.nameEn} & 언더`)
      }
      if (name.indexOf('12 And Under') >= 0) {
        name = name.replace('12 And Under', '12 & 언더')
      }

      if (name.indexOf('1X And Over') >= 0) {
        name = name.replace('1X And Over', '1X & 오버')
        return name;
      }
      if (name.indexOf('X And Over') >= 0) {
        name = name.replace('X And Over', '무 & 오버')
      }
      if (name.indexOf('X2 And Over') >= 0) {
        name = name.replace('X2 And Over', 'X2 & 오버')
      }
      if (name.indexOf('1X And Under') >= 0) {
        name = name.replace('1X And Under', '1X & 언더')
      }
      if (name.indexOf('X And Under') >= 0) {
        name = name.replace('X And Under', '무 & 언더')
      }
      if (name.indexOf('X2 And Under') >= 0) {
        name = name.replace('X2 And Under', 'X2 & 언더')
      }
      if (name.indexOf('ormore') >= 0) {
        name = name.replace('ormore', '골 또는 그이상')
      }
      if (name.indexOf('AnyOther') >= 0) {
        name = name.replace('AnyOther', '기타')
      }
      if (bet.line) name += ` ${bet.line}`;
      if (name === '') {
        name = bet.displayName
      }
      return name;
    },
    // 카트내역 체크해서 표시
    checkCart: function (bets, type) {
      // console.log(this.$store.state.cart[this.cartType]);
      if (type === '보너스') {
        // let index = this.$store.state.cart[this.cartType].find(item => item.odds === event)
        // return !!index;
        return null;
      } else {
        let index = this.cartItem.find(item => item.betsSeq === bets.seq)
        return !!index;
      }
    },
    /**
     * 토글 액션
     * */
    toggleDetail: function (id) {
      this.toggle(this.openDetailBet, id)
    },
    removeAtIndex: function (arr, index) {
      // const copy = [...arr];
      this.openDetailBet.splice(index, 1);
      // return this.openDetailBet;
    },
    toggle: function (arr, item, getValue = item => item) {
      const index = arr.findIndex(i => getValue(i) === getValue(item));
      if (index === -1) {
        this.openDetailBet = [...arr, item]
        return;
      }

      return this.removeAtIndex(arr, index);
    },
    // sortMarket:function(market){
    //   this.lists = this.originList.filter(e => e.marketSeq === market)
    // }
    movePage: function (page) {
      this.$router.push({path: `/${page}`})
    },
    uniqPeriod: function (marketSeq) {
      const periods = this.lists.filter(e => String(e.marketId) === String(marketSeq)).map(e => e.periodSequence);
      let set = new Set(periods);
      const uniqueArr = [...set];
      uniqueArr.sort()
      return uniqueArr
    },
    arrLenDiv: function (arr, div = 4) {
      return Math.floor(arr.length / div) + 1
    },
    // 매치 상태 변경
    matchStats: function (data) {
      const results = JSON.parse(data);
      for (const r in results) {
        const result = results[r];
        if (String(result.EventId) === String(this.game.id)) {
          const score = result.Score;
          console.log('stats', result);
          this.game.homeResult = score.split(':')[0] || 0;
          this.game.awayResult = score.split(':')[1] || 0;
          this.game.currentPeriod = result.Period;
          if (result.RemainingTime) {
            this.game.remainTime = result.RemainingTime;
            setTimeout(()=> {
              this.game.remainTime = null;
            }, 2000)
          }
        }
      }
    },
    // 매치 상태 업데이트
    matchUpdate: function (data) {
      const results = JSON.parse(data);
      for (const r in results) {
        const matchData = results[r];
        // console.log('detailMatchUpdate', matchData);
        if (String(this.game.id) === String(matchData.Id)) {
          // console.log('thisGameUpdate');
          if (matchData.IsStarted) this.game.status = '진행';
          this.game.isVisible = matchData.IsVisible ? 'y' : 'n';
          this.game.isSuspended = matchData.IsSuspended ? 'y' : 'n';
          // if (matchData.MatchStatus === 2){
          // }
        }
      }
    },
    // 인플레이 경기 자세히 내에 해당 폴더 변경
    updateData: function (data) {
      const result = JSON.parse(data);
      const gameMarket = result.filter(e => String(e.MatchId) === (this.game.id))
      if (gameMarket.length > 0) {
        gameMarket.map(m => {
          const folder = this.lists.find(e => String(e.id) === String(m.Id));
          if (folder) {
            folder.isVisible = m.IsVisible ? 'y' : 'n';
            folder.isSuspended = m.IsSuspended ? 'y' : 'n';
            m.Selections.map(s => {
              const bet = folder.bets.find(b => String(b.id) === String(s.Id));
              bet.price = s.Price;
              const cartItem = this.$store.state.sports.cart.find(e => String(e.betsId) === String(s.Id));
              if (cartItem) {
                cartItem.odds =  Number(s.Price).toFixed(2);
                cartItem.betsStatus = s.IsSuspended ? 'y' : 'n';
                cartItem.betsUpdated = true;
              }
            })
          }
        })
      }
    },
    folderClosed: function(seq, period){
      const data = {
        seq,
        period
      };
      const index = this.closed.findIndex(e => e.seq === seq && e.period === period)
      if (index >= 0) return this.closed.splice(index, 1);
      this.closed.push(data);
    }
  }
}
</script>

<style scoped>
.categorys2::-webkit-scrollbar {
  display: none; /* 크롬, 사파리, 오페라, 엣지 */
}
</style>
